import React, { useState } from 'react';

import PropTypes from 'prop-types';

import WarningBar from '../../components/WarningBar/WarningBar';
import SecondaryMarketIdentityUpload from '../../components/SecondaryMarketIdentityUpload/SecondaryMarketIdentityUpload';
import { KYC_NOT_VERIFIED_MESSAGE, checkOnboardingComplete } from '../../utils/constant';

const PortfolioVerificationBanner = ({ userData, navigate }) => {
  const [showIdentityModal, setShowIdentityModal] = useState(false);

  const isAmlDocRequired = !userData?.userData?.isAMLApproved && userData?.userData?.isDocRequiredForAml;
  const isOnboardingComplete = checkOnboardingComplete(userData?.userData, userData?.counter);
  const shouldShowBanner = userData?.isProfileLoaded && (!userData?.userData?.isKYCVerified || isAmlDocRequired);

  if (!shouldShowBanner) return null;

  return (
    <>
      <WarningBar
        action={
          isAmlDocRequired
            ? () => setShowIdentityModal(true)
            : isOnboardingComplete
              ? undefined
              : () => navigate(`/sign-up/verification`)
        }
        message={isAmlDocRequired ? 'Upload required documents to complete your verification and continue investing with Realbricks!' : isOnboardingComplete ? KYC_NOT_VERIFIED_MESSAGE : undefined}
      />
      <SecondaryMarketIdentityUpload
        visible={showIdentityModal}
        onClose={() => setShowIdentityModal(false)}
        onSuccess={() => setShowIdentityModal(false)}
      />
    </>
  );
};

PortfolioVerificationBanner.propTypes = {
  userData: PropTypes.object,
  navigate: PropTypes.func,
};

export default PortfolioVerificationBanner;
